import React from 'react';

function SortableTableTh({
    label,
    sortKey,
    activeSortKey,
    sortDirection,
    onSortAsc,
    onSortDesc,
    compact = false,
    asLabel = false,
    className = '',
}) {
    const isActive = activeSortKey === sortKey;
    const thClassName = compact
        ? `menu-sortable-th menu-sortable-th--compact${asLabel ? ' menu-sortable-th--label' : ''}${className ? ` ${className}` : ''}`
        : `menu-sortable-th${className ? ` ${className}` : ''}`;

    const handleCompactClick = () => {
        if (!isActive) {
            onSortAsc(sortKey);
            return;
        }
        if (sortDirection === 'asc') {
            onSortDesc(sortKey);
            return;
        }
        onSortDesc(sortKey);
    };

    const compactInner = (
        <span className="menu-sortable-th__inner">
            <span>{label}</span>
            {isActive ? (
                <span className="menu-sort-arrow is-active" aria-hidden="true">
                    {sortDirection === 'asc' ? '↑' : '↓'}
                </span>
            ) : null}
        </span>
    );

    if (compact && asLabel) {
        return (
            <span
                className={thClassName}
                onClick={handleCompactClick}
                onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        handleCompactClick();
                    }
                }}
                role="presentation"
            >
                {compactInner}
            </span>
        );
    }

    if (compact) {
        return (
            <th
                className={thClassName}
                onClick={handleCompactClick}
                aria-sort={
                    isActive
                        ? sortDirection === 'asc'
                            ? 'ascending'
                            : 'descending'
                        : 'none'
                }
            >
                {compactInner}
            </th>
        );
    }

    return (
        <th
            className={thClassName}
            aria-sort={
                isActive
                    ? sortDirection === 'asc'
                        ? 'ascending'
                        : 'descending'
                    : 'none'
            }
        >
            <span className="menu-sortable-th__inner">
                <span>{label}</span>
                <span className="menu-sort-arrows" aria-hidden="true">
                    <button
                        type="button"
                        className={`menu-sort-arrow${
                            isActive && sortDirection === 'asc' ? ' is-active' : ''
                        }`}
                        onClick={() => onSortAsc(sortKey)}
                        aria-label={`Sort ${label} ascending`}
                    >
                        ↑
                    </button>
                    <button
                        type="button"
                        className={`menu-sort-arrow${
                            isActive && sortDirection === 'desc' ? ' is-active' : ''
                        }`}
                        onClick={() => onSortDesc(sortKey)}
                        aria-label={`Sort ${label} descending`}
                    >
                        ↓
                    </button>
                </span>
            </span>
        </th>
    );
}

export default SortableTableTh;
